import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { FieldActivityMultipleAction } from '../_models/fieldActivityMultipleAction';
import { FieldActivityPlan } from '../_models/fieldActivityPlan';

@Injectable()
export class FieldActivityMultipleActionSimulationService {
  private apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  // Salva il piano di attività sul campo (crea o aggiorna)
  saveFieldActivityPlan(
    fieldActivityPlanItem: FieldActivityPlan
  ): Observable<FieldActivityMultipleAction> {
    const fieldActivityPlan = { ...fieldActivityPlanItem };
    delete fieldActivityPlan.lastUpdated;
    delete fieldActivityPlan.dateCreated;

    const companySelected = JSON.parse(localStorage.getItem('companySelected'));
    fieldActivityPlan.companyId = companySelected ? companySelected.id : null;

    if (fieldActivityPlan.id) {
      return this.http.put<FieldActivityMultipleAction>(
        `${this.apiBaseUrl}api/private/v1/fieldActivityPlanMultipleActionSimulations/${fieldActivityPlan.id}`,
        fieldActivityPlan
      );
    } else {
      return this.http.post<FieldActivityMultipleAction>(
        `${this.apiBaseUrl}api/private/v1/fieldActivityPlanMultipleActionSimulations`,
        fieldActivityPlan
      );
    }
  }
}
